import { render, staticRenderFns } from "./CrearCertificadoModal.vue?vue&type=template&id=285cdfb3&"
import script from "./CrearCertificadoModal.vue?vue&type=script&lang=ts&"
export * from "./CrearCertificadoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('285cdfb3', component.options)
    } else {
      api.reload('285cdfb3', component.options)
    }
    module.hot.accept("./CrearCertificadoModal.vue?vue&type=template&id=285cdfb3&", function () {
      api.rerender('285cdfb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CertificadosBase/CrearCertificadoModal.vue"
export default component.exports